export const PRIVACY_POLICY = `
<h2 style="text-align:center;"><strong>Privacy Policy</strong></h2>
<h4><strong>Effective Date:</strong> 7 Mar 2025</h4>
<p>Welcome to Mosithunder.com ("we," "our," or "us"). Your privacy is important to us, and this Privacy Policy outlines how we collect, use, disclose, and protect your personal information when you use our website to submit your selections of mash-up combinations for the event <strong>Mosi Lager - Day of Thunder</strong> ("Event").</p>

<p><strong>1. Information We Collect</strong></p>
<p>We may collect the following types of personal information from users:</p>

<p><strong>Personal Information:</strong> Name, email address, phone number, and any other details you voluntarily provide when submitting your mash-up selection.</p>

<p><strong>Technical Information:</strong> IP address, browser type, operating system, and other usage data collected through cookies and similar technologies.</p>

<p><strong>Submission Data:</strong> The combinations of mash-ups submitted by users for the Event.</p>

<p><strong>2. How We Use Your Information</strong></p>
<p>We use the collected information to:</p>

<p>Process and record your mash-up combination submissions for the Event.</p>

<p>Communicate with you regarding your submission or provide updates about the Event.</p>

<p>Improve our website’s functionality and user experience.</p>

<p>Comply with legal obligations and enforce our terms of service.</p>

<p><strong>3. How We Share Your Information</strong></p>
<p>We do not sell or rent your personal information. However, we may share your data in the following circumstances:</p>

<p><strong>Event Organizers:</strong> Your submitted mash-up selections may be shared with event organizers to facilitate the selection process.</p>

<p><strong>Service Providers:</strong> Third-party vendors who assist us in operating our website, conducting analytics, or providing customer support.</p>

<p><strong>Legal Compliance:</strong> If required by law, regulation, or legal process, we may disclose your information to authorities.</p>

<p><strong>4. Data Security</strong></p>
<p>We implement reasonable security measures to protect your personal information from unauthorized access, alteration, or disclosure. However, no method of transmission over the internet is 100% secure, and we cannot guarantee absolute security.</p>

<p><strong>5. Cookies and Tracking Technologies</strong></p>
<p>Our website may use cookies and similar tracking technologies to enhance user experience and collect technical data. You may adjust your browser settings to refuse cookies; however, some website functionalities may be affected.</p>

<p><strong>6. Your Rights and Choices</strong></p>
<p>You may have the right to:</p>

<p>Request access to, update, or delete your personal information.</p>

<p>Opt out of receiving marketing or event-related communications.</p>

<p>Disable cookies through your browser settings.</p>

<p><strong>7. Third-Party Links</strong></p>
<p>Our website may contain links to third-party websites. We are not responsible for their privacy practices, and we encourage users to review their respective privacy policies.</p>

<p><strong>8. Changes to This Privacy Policy</strong></p>
<p>We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated effective date. Your continued use of our website constitutes acceptance of any modifications.</p>

<p><strong>9. Contact Us</strong></p>
<p>If you have any questions about this Privacy Policy, please contact us at:</p>

<p><a href="mailto:mosilagerthunder@gmail.com">mosilagerthunder@gmail.com</a></p>

<p>By using our website, you consent to the collection and use of your information as described in this Privacy Policy.</p>

<p>For more details visit <a href='https://www.ab-inbev.com/terms-and-conditions' target='_blank'>here</a></p<`
